


























import {Vue, Component} from 'vue-property-decorator';
import Tabs from '@/components/Tabs.vue';
import recordTypeList from '@/consts/recordTypeList';
import dayjs from 'dayjs'
import clone from '@/lib/clone';
import _ from 'lodash'
import Chart from '@/components/Chart.vue'


@Component({
  components: {Chart,Tabs}
})

export default class Statistics extends Vue {
  beautify(string: string){
    const day = dayjs(string)
    const now = dayjs()
    if(day.isSame(now,'day')){
      return '今天'
    } else if(day.isSame(now.subtract(1, 'day'),'day')){
      return '昨天'
    }else if(day.isSame(now.subtract(2, 'day'),'day')){
      return '前天'
    }else if(day.isSame(now,'year')){
      return day.format('M月DD日')
    }else{
      return day.format('YYYY年M月DD日')
    }
  }
  tagString(tags: Tag[]){
    return tags.length === 0 ? '无' : tags.map(t=>t.name).join('，')
  }
  get recordList(){
    return (this.$store.state as RootState).recordList
  }

  get keyValuesList(){
    const today = new Date()
    const array = []
    for(let i=0; i<=29; i++){
      const dateString = dayjs(today)
          .subtract(i,'day')
          .format('YYYY-MM-DD')
      array.push({key: dateString, value: _.find(this.groupedList,{title:dateString})?.total
      })
    }
    array.sort((a,b) =>{
      return a.key > b.key ? 1 : a.key === b.key ? 0 : -1;
    })
    return array
  }

  get chartOptions(){
   const keys = this.keyValuesList.map(item=>item.key)
    const values = this.keyValuesList.map(item=>item.value)
    return {
      title: {text: '海青记账',right: '9.3%',top: 10,textStyle:{color: '#22a2c3'}},
      legend: {
        data: ['总计金额'],
        right: 10,
        top: 12
      },
      tooltip: {
        show: true,
        triggerOn: 'click',
        formatter: '{c}',
        position: 'top'
      },
      label: {
        show: false
      },
      grid: {
        left: 0,
        top: 60,
        bottom: 40,
        right: 0,
      },
      xAxis: {
        type: 'category',
        data: keys,
        axisTick: {
          show: true,
          alignWithLabel: true
        },
        axisLabel: {
          interval: 0,
          formatter: function (value:string, index:number) {
            // 格式化成月/日，只在第一个刻度显示年份
            let date = new Date(value);
            let texts = [(date.getMonth() + 1), date.getDate()];
            if (index === 29) {
              texts.unshift(date.getFullYear());
            }
            return texts.join('.');
          }
          // formatter: function (value: string) {
          //   return value.substring(5)
          // }
        },
        axisLine: {
          lineStyle: {
            color: '#666'
          }
        }
      },
      yAxis: {
        type: 'value',
        show: false
      },
      series: [{
        name: '总计金额',
        connectNulls: true,
        symbol: 'circle',
        symbolSize: 10,
        itemStyle: {
          borderWidth: 10,
          color: '#22a2c3'
        },
        lineStyle: {
          width: 2
        },
          data: values,
          type: 'line',
          smooth: true
        }]
    }
  }

  get groupedList(){
    const {recordList} = this

    const newList = clone(recordList)
        .filter(r =>r.type === this.type)
        .sort((a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf())
    if(newList.length === 0){return [] as Result}
    type Result = {title: string,total?: number, items: RecordItem[] }[]

    const result: Result = [{title: dayjs(newList[0].createdAt).format('YYYY-MM-DD'), items: [ newList[0] ] }]
    for(let i=1;i<newList.length;i++){
      const current = newList[i]
      const last = result[result.length -1]
      if(dayjs(last.title).isSame(dayjs(current.createdAt),'day')){
        last.items.push(current)
      }else{
        result.push({title: dayjs(current.createdAt).format('YYYY-MM-DD'), items: [ current ] })
      }
    }
     result.forEach(group =>{
      group.total = group.items.reduce((sum, item) => sum +item.amount, 0)
    })
    return result
  }
  mounted(){
    const div = (this.$refs.wrapper as HTMLDivElement)
    div.scrollLeft = div.scrollWidth
  }
  created(){
    this.$store.commit('fetchRecords')
  }
  type = '-'
  recordTypeList = recordTypeList

}
